import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    take : 25,
    skip: 0,
    activePagination : false,
    columns: [
            {
                table: "currencies",
                direction : "ASC",
                direction_pos : 0,
                key : "name",
                label : "name",
                display : true
            },
            {
                table: "currencies",
                direction : "ASC",
                direction_pos : 0,
                key : "iso_code",
                label : "ISO",
                display : true
            },
            {
                table: "currencies",
                direction : "ASC",
                direction_pos : 0,
                key : "symbol",
                label : "symbol",
                display : true
            },
        ],
    emptyObject : {id : 0, name: "", symbol: "", iso_code: ""},
    loaded : false,
    loadingMore: false,
    loading: false,
    allLoaded : false,
    addNew : false,
    workingOn: [],
    infinity : {
        active : false,
        columns: ["name", "iso_code", "symbol"],
    },
    pagination: {
        currentPage: 1,
        totalPageCount: 0,
        pagesize: 5
    },
    meta : {},
})

  // getters
  const getters = {
      isWorkingOn : (state) => (id) => {
          var index = state.workingOn.findIndex(id);
          if(index >= 0){
              return true;
          }else{
              return false;
          }
      },
      getCurrencyById: (state) => (id) => {
          var index = state.list.findIndex(item => item.id == id);
          if(index > -1){
              return state.list[index];
          }
          return {name : "", iso_code : "", symbol: ""};
      },
      invoiceSymbol: (state, getters) => (id) => {
        var currency =  getters["getCurrencyById"](id);
        if(currency.symbol != undefined && currency.symbol.trim() != ""){
          return currency.symbol;
        }
        return currency.iso_code ?? "";
      },
      getIsoCode: (state, getters) => (id) => {
        var currency =  getters["getCurrencyById"](id);
        return currency.iso_code ?? "";
      }
  }

  // actions
  const actions = {
      async update({commit, state, rootState}, data){
          await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/currencies/" + data.id, data).then(response => {
            commit("update", response.data.data);
          })
      },
      async store({commit, state, rootState}, data){
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/currencies", data).then(response => {
            commit("unshift", response.data.data);
        })
    },
    async load({commit, state, rootState}, page = 1){
        commit("skip", (page - 1) * state.take);

        commit("isLoading", true);
        if(state.allLoaded == false){
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/currencies", {params: {take: state.take, skip:state.skip, activePagination : state.activePagination, table_columns: state.columns}}).then((response) => {
                commit("set", response.data.data);
                commit("pagination", _.get(response, "data.meta.pagination", { total: 0, take: state.take }))
                commit("isLoading", false);
            })
        }
        commit("isLoading", false);
    },
     async delete({commit, state, rootState}, data){
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/currencies/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
    }
  }

  // mutations
  const mutations = {
    removeId(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
    pagination(state, object) {
        state.meta = object;
        if (state.skip <= 0) {
            state.pagination.currentPage = 1;
        } else {
            state.pagination.currentPage = (state.skip / state.take) + 1;
        }
        state.pagination.totalPageCount = Math.ceil(state.meta.total / state.take);
        if(state.infinity.active == true && state.meta.total <= state.skip){
            state.allLoaded = true;
        }
    },
    skip(state, skip) {
        state.skip = skip;
    },
    activatePagination(state, status){
        state.activePagination = status;
    },
    set(state, list){
        if(list == undefined || list.length <= 0){
          state.allLoaded = true;
        }
        if (state.infinity.active == true) {
          state.list.push(...list);
      } else {
          state.list = list;
      }
    },
      clean(state){
        state.list = [];
        state.allLoaded = false;
        state.workingOn = [];
        state.loaded = false;
      },

      update(state, element){
        var index = state.list.findIndex(item => item.id == element.id);
        state.list[index] = element;
    },
      unshift(state, element){
        state.list.unshift(element);
      },
      unmount(state){
          state.allLoaded = false;
          state.loading = true;
          state.list = [];
          state.workingOn = [];
      },
      increasePage(state){
          state.loadingMore = true;
          state.page++;
      },
      isLoading(state, status){
          state.loadingMore = status;
          state.loading = status;
      },
      updateColumn(state, column){
        var index = state.columns.findIndex(item => item.key == column.key)
        for(let i in state.columns){
            state.columns[i].direction_pos += 1;
        }
        if(index > -1){
            column.direction_pos = 0;
            state.columns[index] = column;
        }
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
